var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M650 325C650 504.492 504.492 650 325 650 145.508 650 0 504.492 0 325 0 145.508 145.508 0 325 0 504.492 0 650 145.508 650 325Z",
    stroke: "#7F7F7F",
    strokeWidth: 45.8333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 423.652C271.949 423.652 238.074 417.687 196.182 409.517 186.614 407.665 168 409.517 168 437.787 168 494.326 232.748 565 323 565 413.238 565 478 494.326 478 437.787 478 409.517 459.386 407.651 449.818 409.517 407.926 417.687 374.051 423.652 323 423.652Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 262C262 296.794 241.853 325 217 325 192.147 325 172 296.794 172 262 172 227.206 192.147 199 217 199 241.853 199 262 227.206 262 262Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 261.5C478 296.57 457.853 325 433 325 408.147 325 388 296.57 388 261.5 388 226.43 408.147 198 433 198 457.853 198 478 226.43 478 261.5Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.987 182C517.485 182 512.09 179.53 508.536 174.842 464.657 116.791 391.009 159.703 387.906 161.546 379.336 166.646 368.258 163.872 363.152 155.408 358.028 146.926 360.788 135.939 369.34 130.856 405.389 109.4 486.867 86.5308 537.385 153.35 543.375 161.26 541.751 172.48 533.777 178.403 530.547 180.837 526.758 182 522.987 182ZM126.023 182C122.271 182 118.464 180.837 115.216 178.421 107.241 172.498 105.636 161.278 111.608 153.368 162.144 86.5487 243.622 109.418 279.653 130.874 288.205 135.956 290.965 146.944 285.841 155.426 280.717 163.89 269.675 166.664 261.123 161.582 257.894 159.685 184.011 117.292 140.457 174.86 136.939 179.53 131.508 182 126.023 182Z",
    fill: "#7F7F7F",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceIcon);
export default __webpack_public_path__ + "static/media/faceIcon.5a20ca8becec2115dc720be25f26d92d.svg";
export { ForwardRef as ReactComponent };